import type { HeaderImage } from './api'
import { apiFetch } from './api'

export type HeaderImageCategory = 'minimal' | 'nature' | 'more'

export async function fetchHeaderImagePhotos(
  workspaceId: string,
  category: HeaderImageCategory,
  page = 1,
) {
  const params = new URLSearchParams({
    workspaceId,
    category,
    page: String(page),
  })

  return apiFetch<HeaderImage[]>(`/api/knowledge/unsplash/photos?${params.toString()}`)
}

export type { HeaderImage }
